export const environment = {
  production: false,
  apiUrl: '',
  apiClientKey: '',
  juliaApiUrl: '',
  xHeaderName: '',
  csrfCookieName: '',
  juliaLogo: 'assets/logo/logo_ibs.png',
  logoLogin: 'assets/images/logoLoginTnegoce.png',
  logoSideBarOpenCorporate: 'assets/images/logoSideBarOpenCorporateTnegoce.png',
  logoSideBarOpenBank: 'assets/images/logoSideBarOpenBankTnegoce.png',
  logoSideBarOpenAdmin: 'assets/images/logoSideBarOpenAdminTnegoce.png',
  logoSideBarCollapsedCorporate: 'assets/images/logoSideBarCollapsedCorporate.png',
  logoSideBarCollapsedBank: 'assets/images/logoSideBarCollapsedBank.png',
  logoSideBarCollapsedAdmin: 'assets/images/logoSideBarCollapsedAdmin.png'
};
